export default {
    list_users: 'Pesquisar pelo Nome ou E-mail',
    list_customers: 'Pesquisar pelo Nome, E-mail ou Organização',
    list_calls: 'Pesquisar pelo Número ou Título',
    list_tasks: 'Pesquisar pelo Número, Título ou Descrição',
    list_attendance_groups: 'Pesquisar pelo Nome ou Organização',
    list_sla_config: 'Pesquisar pelo Grupo ou Categoria',
    list_organizations: 'Pesquisar pelo Nome, Site ou Telefone',
    by_name_or_description: 'Pesquisar pelo Nome ou Descrição',
    by_description: 'Pesquisar pela Descrição',
    by_name: 'Pesquisar pelo Nome',
    by_title_or_content: 'Pesquisar pelo Título ou Conteúdo',
}
